/**
 * abilityVfxFluxOrb — Ryze E Spell Flux runic orb + spread (SP-11).
 */
export function buildFluxOrb(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.38 * (spec.scale || 1);
  const ink = mat(THREE, spec.color || 0x6366f1, 0.92);
  const glow = mat(THREE, 0xa5b4fc, 0.88);
  const deep = mat(THREE, 0x4338ca, 0.9);
  addCoreAndHalo(THREE, group, s, ink, glow);
  addGlyphs(THREE, group, s, glow);
  addSpreadSparks(THREE, group, s, ink, deep);
  addFluxRing(THREE, group, s, ink, glow);
  group.userData = { shape: 'flux_orb' };
  return group;
}

function addCoreAndHalo(THREE, group, s, ink, glow) {
  group.add(new THREE.Mesh(new THREE.SphereGeometry(s, 12, 12), glow));
  const core = new THREE.Mesh(new THREE.SphereGeometry(s * 0.55, 10, 10), ink);
  group.add(core);
  const halo = new THREE.Mesh(
    new THREE.RingGeometry(s * 1.15, s * 1.55, 18),
    ink
  );
  if (!halo.rotation) halo.rotation = { x: 0 };
  halo.rotation.x = Math.PI / 2;
  group.add(halo);
}

function addGlyphs(THREE, group, s, glow) {
  for (let i = 0; i < 3; i += 1) {
    const glyph = new THREE.Mesh(new THREE.BoxGeometry(0.1 * s, 0.2 * s, 0.04 * s), glow);
    const a = (Math.PI * 2 / 3) * i;
    glyph.position.set(Math.cos(a) * s * 0.9, Math.sin(a) * s * 0.55, 0);
    group.add(glyph);
  }
}

function addSpreadSparks(THREE, group, s, ink, deep) {
  for (let i = 0; i < 5; i += 1) {
    const a = (Math.PI * 2 / 5) * i;
    const spark = new THREE.Mesh(new THREE.BoxGeometry(0.07 * s, 0.07 * s, 0.5 * s), deep);
    spark.position.set(Math.cos(a) * s * 0.35, 0.2 * s, Math.sin(a) * s * 0.35);
    if (!spark.rotation) spark.rotation = { y: 0 };
    spark.rotation.y = a;
    group.add(spark);
    const tip = new THREE.Mesh(new THREE.SphereGeometry(0.06 * s, 8, 8), ink);
    tip.position.set(Math.cos(a) * s * 0.85, 0.2 * s, Math.sin(a) * s * 0.85);
    group.add(tip);
  }
}

function addFluxRing(THREE, group, s, ink, glow) {
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(s * 1.4, s * 1.75, 20).rotateX(-Math.PI / 2),
    ink
  );
  outer.position.y = 0.05;
  group.add(outer);
  const inner = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.55, s * 0.8, 16).rotateX(-Math.PI / 2),
    glow
  );
  inner.position.y = 0.06;
  group.add(inner);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
